export default __webpack_public_path__ + "static/media/BiofuelCircle_Logo.a4ae2979.png";